import Button from '@ui/Button';
import Input from '@ui/Input';
import React, { useEffect } from 'react';
import * as yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Typography from '@ui/Typography';
import { defaults, pick } from 'lodash-es';
import StyledButtonNew from 'components/Styled/StyledButtonNew';
import StyledContainedButton from '../../Styled/StyledContainedButton';

const schema = yup.object().shape({
  email: yup
    .string()
    .email('Invalid email')
    .max(100, 'Email must be less than 100 characters')
    .required('Email is required'),
  twitter: yup
    .string()
    .url('Twitter id must be a url')
    .max(100, 'Twitter id must be less than 100 characters')
    .nullable()
    .notRequired(),
  facebook: yup
    .string()
    .url('Facebook id must be a url')
    .max(100, 'Facebook id must be less than 100 characters')
    .nullable()
    .notRequired(),
  linkedin: yup
    .string()
    .url('LinkedIn id must be a url')
    .max(100, 'LinkedIn id must be less than 100 characters')
    .nullable()
    .notRequired(),
  instagram: yup
    .string()
    .url('Instagram id must be a url')
    .max(100, 'Instagram id must be less than 100 characters')
    .nullable()
    .notRequired(),
  // phoneNumber: yup
  //   .string()
  //   .transform((value, originalValue) => (originalValue === '' ? null : value))
  //   .matches(
  //     /^(?:\+?\d{1,4}[-.\s]?)?(?:\(?\d{1,3}\)?[-.\s]?)?\d{1,4}[-.\s]?\d{1,9}$/,
  //     'Invalid phone number',
  //   )
  //   .max(30, 'Phone number must be less than 30 characters')
  //   .nullable()
  //   .notRequired(),
  phoneNumber: yup
    .string()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .required('Phone number is required')
    .matches(
      /^\+?[1-9]\d{7,14}$/,
      'Invalid phone number (use country code, e.g. +14155551234)',
    )
    .nullable()
    .notRequired(),
});

function EditProfileContactStep(props) {
  const { userProfile, onSubmit, onBack, formData, onNext, saving } = props;

  const defaultValues = defaults(
    pick(formData, [
      'email',
      'twitter',
      'facebook',
      'linkedin',
      'instagram',
      'phoneNumber',
    ]),
    {
      email: userProfile ? userProfile.email : '',
      twitter: userProfile ? userProfile.twitterProfile : null,
      facebook: userProfile ? userProfile.facebookProfile : null,
      linkedin: userProfile ? userProfile.linkedin_profile : null,
      instagram: userProfile ? userProfile.instagramProfile : null,
      phoneNumber: userProfile ? userProfile.phoneNumber : null,
    },
  );

  const form = useForm({
    defaultValues: defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    watch,
    trigger,
  } = form;

  const handleFormSubmit = async (data) => {
    onSubmit(data, 'Contact Information');
  };

  return (
    <div className="flex w-full flex-1 flex-col gap-12">
      <form
        onSubmit={handleSubmit(handleFormSubmit)}
        className="flex flex-col gap-6">
        <Controller
          name="email"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <Input
              label="EMAIL"
              disabled
              // readonly // Show the field as readonly, if needed
              required
              {...rest}
              error={errors.email?.message}
              className="hover:cursor-not-allowed"
            />
          )}
        />

        <div className="flex gap-6">
          <div className="flex w-1/2 flex-col">
            <Controller
              name="twitter"
              control={control}
              render={({ field: { ref, ...rest } }) => (
                <Input
                  label="TWITTER ID"
                  {...rest}
                  error={errors.twitter?.message}
                />
              )}
            />
          </div>
          <div className="flex w-1/2 flex-col">
            <Controller
              name="facebook"
              control={control}
              render={({ field: { ref, ...rest } }) => (
                <Input
                  label="FACEBOOK ID"
                  {...rest}
                  error={errors.facebook?.message}
                />
              )}
            />
          </div>
        </div>

        <div className="flex gap-6">
          <div className="flex w-1/2 flex-col">
            <Controller
              name="linkedin"
              control={control}
              render={({ field: { ref, ...rest } }) => (
                <Input
                  label="LINKEDIN ID"
                  {...rest}
                  error={errors.linkedin?.message}
                />
              )}
            />
          </div>
          <div className="flex w-1/2 flex-col">
            <Controller
              name="instagram"
              control={control}
              render={({ field: { ref, ...rest } }) => (
                <Input
                  label="INSTAGRAM ID"
                  {...rest}
                  error={errors.instagram?.message}
                />
              )}
            />
          </div>
        </div>

        <Controller
          name="phoneNumber"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <Input
              label="PHONE NUMBER"
              placeholder="Phone Number (e.g. +14155551234)"
              {...rest}
              error={errors.phoneNumber?.message}
            />
          )}
        />

        <div className="flex-rows flex justify-end gap-4 pb-4">
          {/* <div className="flex-flow-col">
            <Button
              variant="outlined"
              color="primary"
              className="mt-2"
              onClick={onBack}>
              Back
            </Button>
          </div> */}
          {isValid ? (
            <div className="flex-flow-col">
              <StyledContainedButton
                variant="filled"
                color="primary"
                type="submit"
                className="mt-2"
                loading={saving}
                // onClick={onNext}
              >
                Save
              </StyledContainedButton>
            </div>
          ) : (
            <div className="flex-flow-col">
              <StyledContainedButton
                disabled={true}
                variant="outlined"
                color="primary"
                type="submit"
                className="mt-2"
                // onClick={onNext}
              >
                Save
              </StyledContainedButton>
            </div>
          )}
        </div>
      </form>
    </div>
  );
}

export default EditProfileContactStep;
